<script lang="ts" setup>
import { TOOLTIP_OPEN_DELAY_MS } from '@/constants/practiceConstants'

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    modelValue: boolean
  }>(),
  { disabled: false },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()
</script>

<template>
  <v-tooltip bottom :open-delay="TOOLTIP_OPEN_DELAY_MS" text="Torah scroll style (no vowels or cantillation)">
    <template #activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        :active="modelValue"
        color="primary"
        :disabled="props.disabled"
        icon
        style="align-self: stretch"
        :variant="modelValue ? 'flat' : 'outlined'"
        @click="emit('update:modelValue', !modelValue)"
      >
        <svg fill="currentColor" height="1.4em" viewBox="0 0 32 24" width="1.9em" xmlns="http://www.w3.org/2000/svg">
          <rect height="16" rx="1.5" width="3.5" x="1" y="4" />
          <circle cx="2.75" cy="3" r="2.2" />
          <circle cx="2.75" cy="21" r="2.2" />
          <rect height="16" rx="1.5" width="3.5" x="27.5" y="4" />
          <circle cx="29.25" cy="3" r="2.2" />
          <circle cx="29.25" cy="21" r="2.2" />
          <rect height="14" opacity="0.15" rx="0.5" width="20" x="6" y="5" />
          <rect height="1.2" rx="0.5" width="14" x="9" y="8" />
          <rect height="1.2" rx="0.5" width="14" x="9" y="11" />
          <rect height="1.2" rx="0.5" width="9" x="9" y="14" />
        </svg>
      </v-btn>
    </template>
  </v-tooltip>
</template>
